import { JsonHierarchyElement } from "@psnb/nwt-api";

export class HierarchyNodeList {
  constructor(
    public item: JsonHierarchyElement,
    public level: number = 1,
    public expandable: boolean = false,
    public isLoading: boolean = false)
    { }
}